import { createSingleUseObserver } from '../util/intersection-observer';

class StatsCounter {
	constructor(el) {
		this.el = el;
		this.duration = 3200;
		this.stats = Array.from(this.el.querySelectorAll('.stat__stat'))
			.map((stat) => this.getStatData(stat))
			.filter((stat) => stat !== null);

		if (!this.stats.length) {
			return;
		}

		if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
			return;
		}

		const rect = this.el.getBoundingClientRect();
		const isInitiallyVisible =
			rect.top < window.innerHeight &&
			rect.bottom > 0;

		if (isInitiallyVisible) {
			this.start();
			return;
		}

		createSingleUseObserver(this.el, () => this.start());
	}

	getStatData(el) {
		const originalText = el.textContent.trim();
		const match = originalText.match(/-?\d[\d,]*(?:\.\d+)?/);

		if (!match) {
			return null;
		}

		const numberText = match[0];
		const decimalPoint = numberText.indexOf('.');

		return {
			decimals: decimalPoint === -1 ? 0 : numberText.length - decimalPoint - 1,
			el,
			prefix: originalText.slice(0, match.index),
			suffix: originalText.slice(match.index + numberText.length),
			target: Number(numberText.replace(/,/g, ''))
		};
	}

	formatValue(value, decimals) {
		return value.toLocaleString('en-US', {
			maximumFractionDigits: decimals,
			minimumFractionDigits: decimals
		});
	}

	start() {
		let startTime = null;

		this.stats.forEach((stat) => {
			stat.el.textContent = `${stat.prefix}${this.formatValue(0, stat.decimals)}${stat.suffix}`;
		});

		const update = (timestamp) => {
			if (startTime === null) {
				startTime = timestamp;
			}

			const progress = Math.min((timestamp - startTime) / this.duration, 1);
			const easedProgress = 1 - Math.pow(1 - progress, 3);

			this.stats.forEach((stat) => {
				const value = stat.target * easedProgress;
				stat.el.textContent = `${stat.prefix}${this.formatValue(value, stat.decimals)}${stat.suffix}`;
			});

			if (progress < 1) {
				window.requestAnimationFrame(update);
			}
		};

		window.requestAnimationFrame(update);
	}
}

export default StatsCounter;
